class LocalizationForm extends HTMLElement {
  constructor() {
    super()

    this.elements = {
      toggleButton: this.querySelector('.localization__button'),
      selector: this.querySelector('.localization__selector'),
      input: this.querySelector('input[name="language_code"], input[name="country_code"], input[name="market_handle"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    this.all_forms = document.querySelectorAll("localization-form")

    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    // Desktop Dropdown
    if (this.elements.toggleButton !== null) {
      this.elements.toggleButton.addEventListener('click', (e) => {
        e.stopPropagation()
        this.all_forms.forEach((item) => { if (item !== this) { item.hide() } })
        this.toggle()
      })
    }
    if (this.elements.selector !== null) {
      this.elements.selector.querySelectorAll('button').forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault()

          const form = this.querySelector('form')
          this.elements.input.value = button.dataset.value
          if (form) form.submit()
        })
      })
    }

    document.addEventListener('click', this.handleDocumentClick)


    // Mobile Select
    this.querySelectorAll('select').forEach(selectElement => {

      if (selectElement.dataset.value !== null) {
        selectElement.value = selectElement.dataset.value
      }

      selectElement.addEventListener('change', (e) => {
        e.preventDefault()
        const form = this.querySelector('form')
        if (form) form.submit()
      })
    })

  }

  // async detectLocalization() {
  //   const locale = await fetch(
  //     window.Shopify.routes.root
  //       + 'browsing_context_suggestions.json'
  //       + '?country[enabled]=true'
  //       + `&country[exclude]=${window.Shopify.country}`
  //       + '&language[enabled]=true'
  //       + `&language[exclude]=${window.Shopify.language}`
  //   ).then(r => r.json());
  //   const detectedCountry = locale.detected_values.country.handle.toLowerCase()
  // }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hide()
    }
  }

  toggle() {
    this.elements.selector.hidden = !this.elements.selector.hidden
  }

  hide() {
    if (!this.elements.selector.hidden) {
      this.elements.selector.hidden = true
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick)
  }
}

customElements.define('localization-form', LocalizationForm)

